// @core/api/endpoints/notifications/list_contacts_by_entity.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListContactsResponse,
} from '../../../types/notifications';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/notifications';

/**
 * List contacts for entity
 * Retrieves all contacts associated with a specific entity such as a user profile or team. Useful for finding all notification endpoints for an entity.
 */
export async function ListContactsByEntity(
  entity_type: string,
  entity_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListContactsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/entities/:entity_type/:entity_id/contacts`;
  requestPath = requestPath.replace(':entity_type', encodeURIComponent(entity_type));
  requestPath = requestPath.replace(':entity_id', encodeURIComponent(entity_id));
  const requestOptions = options;
  return client.get<ListContactsResponse>(requestPath, { ...requestOptions, params });
}
